var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container feedback template-bg-gray" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec" },
        [
          _c(
            "div",
            {
              staticClass:
                "loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "div",
                {
                  staticClass: "card form-wrapper",
                  class: { thankupageplr88: _vm.success }
                },
                [
                  _c(
                    "div",
                    { staticClass: "feedback_container" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "grid",
                            "place-items": "center"
                          }
                        },
                        [
                          _c("img", {
                            style: { width: "128px", maxHeight: "128px" },
                            attrs: {
                              src: _vm.logoURL,
                              alt:
                                "Community Logo of " +
                                _vm.community.content.parameter4
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.success === false
                        ? [
                            _c("header", { attrs: { "aria-live": "polite" } }, [
                              _c(
                                "h1",
                                {
                                  staticClass:
                                    "template-title text-center common-space-from-logo mb10"
                                },
                                [
                                  _vm._v(
                                    "Sorry to see you\n                                    go!\n                                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "custom-content my-text-center mb30",
                                  attrs: { tabindex: "0" }
                                },
                                [
                                  _vm._v(
                                    "Complete the below form to unsubscribe\n                                    from " +
                                      _vm._s(_vm.community.content.parameter2)
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass: "template-form",
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.unsubscribeUser.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-6 mr-1 mb-17" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass: "template-label",
                                              attrs: {
                                                for: "unsusbcribe-email"
                                              }
                                            },
                                            [_vm._v("Email")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "required-symbol" },
                                            [_vm._v(" *")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.email,
                                                expression: "email"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|email|max:60",
                                                expression:
                                                  "'required|email|max:60'"
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-value pt-input w-100 input-focus",
                                            class: [
                                              {
                                                "b-error": _vm.errors.has(
                                                  "email"
                                                )
                                              },
                                              "form-control",
                                              "pt-input",
                                              "input-focus"
                                            ],
                                            attrs: {
                                              type: "text",
                                              id: "unsusbcribe-email",
                                              name: "email",
                                              required: "",
                                              "aria-invalid": _vm.errors.has(
                                                "email"
                                              ),
                                              "aria-describedby": "email-error",
                                              "aria-required": "true"
                                            },
                                            domProps: { value: _vm.email },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.email = $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "email"
                                                  ),
                                                  expression:
                                                    "errors.has('email')"
                                                }
                                              ],
                                              staticClass: "error",
                                              attrs: {
                                                id: "email-error",
                                                role: "alert"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.errors.first("email")
                                                  ) +
                                                  "\n                                            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-35" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "template-label",
                                          attrs: { for: "unsusbcribe-combobox" }
                                        },
                                        [
                                          _vm._v(
                                            "Unsubscribe\n                                                Reason"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.reason,
                                              expression: "reason"
                                            }
                                          ],
                                          staticClass:
                                            "form-control mb-16 pt-input input-focus input-focus select-dropdown requestPageDropdown template-dform-control input-value pt-input w-100 input-focus",
                                          attrs: {
                                            id: "unsusbcribe-combobox",
                                            name: "reason"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.reason = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                                selected: "",
                                                hidden: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "Can you tell us why?\n                                                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "Don't have time"
                                              }
                                            },
                                            [_vm._v("Don't have time")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "Not relevant to me"
                                              }
                                            },
                                            [_vm._v("Not relevant to me")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "Poor experience"
                                              }
                                            },
                                            [_vm._v("Poor experience")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "Too many emails"
                                              }
                                            },
                                            [_vm._v("Too many emails")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "Other" } },
                                            [_vm._v("Other")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has("reason"),
                                              expression: "errors.has('reason')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(_vm.errors.first("reason"))
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12 mt-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2"
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "template-label",
                                            attrs: { for: "description-field" }
                                          },
                                          [
                                            _vm._v(
                                              "Tell us more about\n                                                your experience"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.description,
                                              expression: "description"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate.continues",
                                              value: "max:500",
                                              expression: "'max:500'",
                                              modifiers: { continues: true }
                                            }
                                          ],
                                          staticClass:
                                            "form-control placeholder-bold",
                                          class: {
                                            "request-form-error-border": _vm.errors.has(
                                              "description"
                                            )
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "description-field",
                                            "aria-describedby":
                                              "description-help description-counter",
                                            rows: "5",
                                            cols: "5",
                                            name: "description",
                                            placeholder:
                                              "Is there anything else you'd like us to know?",
                                            "aria-label":
                                              "Unsubscribe reason - maximum 500 characters",
                                            maxlength: _vm.max
                                          },
                                          domProps: { value: _vm.description },
                                          on: {
                                            keyup: _vm.countdown,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.description =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group pd-remove unsubscribe-btn mb-0-custom"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "char-counter template-subject-counter",
                                                class: {
                                                  "char-count-error":
                                                    _vm.exceedsMaxCount
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(_vm.remainingCount) +
                                                    " / 500"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "sr-only",
                                            attrs: { id: "description-help" }
                                          },
                                          [
                                            _vm._v(
                                              "Please provide details about\n                                                your experience (500 characters maximum)"
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "description"
                                            ),
                                            expression:
                                              "errors.has('description')"
                                          }
                                        ],
                                        staticClass: "error"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.errors.first("description")
                                            )
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "btn-block text-right mlr0" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "btn template-review-submit template-button template-button-width mlr0",
                                        style: _vm.unsubscribeBtn,
                                        attrs: {
                                          type: "submit",
                                          name: "unsubscribe"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Unsubscribe\n                                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        : [_vm._m(1)]
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-inline text-center footer-links" },
                [
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.landingPageURL &&
                    _vm.community.content.landingPageURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.landingPageURL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [_vm._v("Learn More")]
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)", tabindex: "0" }
                          },
                          [_vm._v("Learn More")]
                        )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.community.content &&
                    _vm.community.content.termsConditionsURL &&
                    _vm.community.content.termsConditionsURL.length
                      ? _c(
                          "a",
                          {
                            staticClass: "links",
                            attrs: {
                              href: _vm.community.content.termsConditionsURL,
                              target: "_blank",
                              tabindex: "0"
                            }
                          },
                          [_vm._v("Terms Of Use [pdf]")]
                        )
                      : _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)", tabindex: "0" }
                          },
                          [_vm._v("Terms Of Use [pdf]")]
                        )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "unsubscribe-community-logo" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "https://www.protopia.co", target: "_blank" }
                  },
                  [
                    _c("img", {
                      attrs: {
                        loading: "lazy",
                        src: this.footerLogoURL,
                        alt:
                          "Community Logo of " +
                          _vm.community.content.parameter4
                      }
                    }),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(
                        "Protopia\n                            - Visit our site"
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticClass: "required-note template-label",
        attrs: { id: "required-note" }
      },
      [
        _vm._v(
          "\n                                    Fields marked with an asterisk ("
        ),
        _c("span", { staticClass: "required-symbol" }, [_vm._v("*")]),
        _vm._v(
          ") are\n                                    required.\n                                "
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-text" }, [
      _c(
        "h1",
        { staticClass: "template-title my-text-center common-space-from-logo" },
        [_vm._v("Thank you!")]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "box-sub-heading mb35 custom-content my-text-center" },
        [
          _vm._v(
            "You have successfully\n                                    unsubscribed."
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3b45f52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3b45f52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberUnsubscribe.vue
// module id = null
// module chunks = 